import { FC } from 'react';
import classnames from 'classnames';
import { Props } from './types';
import { translationData } from './data';
import DeviceManager from '../../../util/deviceManager';

const GuideModal: FC<Props & { children?: any }> = ({ show, onContinue, translation, logo }) => {
  if (!show) return null;
  const labels = translationData(translation);
  const isMobile = DeviceManager.isMobile();
  const horMobile = DeviceManager.isHorizontalMobileView();
  return (
    <div className={classnames('gb-guide-wrapper', isMobile && 'mobile')}>
      <div className={classnames('gb-guide', isMobile && 'mobile')}>
        {isMobile && <img src={logo} className="gb-guide-logo" alt="" />}
        <div className="gb-guide-title">
          {!isMobile && <div className="line mr-3" />}
          <span className="title-label">{labels.guideLabel}</span>
          {!isMobile && <div className="line ml-3" />}
        </div>
        <div className={classnames('gb-guide-content', horMobile && 'horizontal')}>
          <div>
            <span className="content-title">{labels.walkAroundLabel}</span>
            <div className="content-wrapper">
              <div className="content-group">
                <div className="image one" />
                <span className="text">{labels.waClickLabel}</span>
              </div>
              <div className="content-group">
                <div className="image two" />
                <span className="text">{labels.waKeyboardLabel}</span>
              </div>
              <div className="content-group">
                <div className="image three" />
                <span className="text">{labels.waMouseLabel}</span>
              </div>
              <div className="content-group">
                <div className="image four" />
                <span className="text">{labels.waSpaceLabel}</span>
              </div>
            </div>
          </div>
          {!horMobile && <div className="content-line" />}
          <div>
            <span className="content-title">{labels.engagementLabel}</span>
            <div className="content-wrapper">
              <div className="content-group item-3">
                <div className="image five" />
                <span className="text">{labels.eVirtualButtonsLabel}</span>
              </div>
              <div className="content-group item-3">
                <div className="image six" />
                <span className="text">{labels.eBookButtonLabel}</span>
              </div>
              <div className="content-group item-3">
                <div className="image seven">
                  <a className="next-btn no-btn">
                    {translation.goNow || 'Go Now'}
                    <i className="fas fa-running" />
                  </a>
                </div>
                <span className="text">{labels.eGoButtonLabel}</span>
              </div>
            </div>
          </div>
          <div className="guide-footer d-flex justify-content-center">
            <a className="next-btn" onClick={onContinue}>
              {labels.goButtonLabel} <i className="fas fa-check-circle" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuideModal;
